import { createStore, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import createTransform from "redux-persist/es/createTransform";
import storage from "redux-persist/lib/storage";

import { reducer as servicesReducer } from "./services/reducer";

const rootReducer = combineReducers({
  services: servicesReducer,
});

const PersistCheck = createTransform(
  inbound => {
    if (!inbound.session || inbound.session.persist) {
      return inbound;
    } else {
      return;
    }
  },
  outbound => {
    return outbound;
  },
);

const persistConfig = {
  key: "root",
  transforms: [PersistCheck],
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
